import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
const initialState = {
    passClaimStatusById: {},
    successes: [],
    failures: [],
    status: 'init'
};
export const fetchParrotPassesTokenClaimStatus = createAsyncThunk('crypto/fetchClaimedParrotPasses', async (_, thunkApi) => {
    try {
        return await (await api.instance).fetchParrotPassesTokenClaimStatus();
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchParrotPassTokenClaimStatus = createAsyncThunk('crypto/fetchClaimedParrotPass', async (pass, thunkApi) => {
    try {
        return await (await api.instance).fetchParrotPassTokenClaimStatus(pass);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const claimParrotTokens = createAsyncThunk('crypto/claimParrotTokens', async (passes, thunkApi) => {
    try {
        const response = await (await api.instance).claimParrotTokens(passes);
        return response;
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
const applyClaimStatusState = (state, passes) => {
    passes.forEach((pass) => {
        state.passClaimStatusById[pass.passId] = pass;
        if (typeof pass.claimAttemptStatus !== 'undefined') {
            if (pass.claimAttemptStatus === 'Success') {
                state.successes.push(pass.passId);
            }
            else {
                state.failures.push(pass.passId);
            }
        }
    });
};
const claimParrotTokensSlice = createSlice({
    name: 'claimedParrotPass',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchParrotPassTokenClaimStatus.fulfilled, (state, action) => {
            state.passStatus = action.payload;
            state.status = 'success';
        })
            .addCase(fetchParrotPassesTokenClaimStatus.fulfilled, (state, action) => {
            applyClaimStatusState(state, action.payload);
            state.status = 'success';
        })
            .addCase(claimParrotTokens.fulfilled, (state, action) => {
            applyClaimStatusState(state, action.payload);
            state.status = 'success';
        })
            .addCase(fetchParrotPassTokenClaimStatus.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchParrotPassesTokenClaimStatus.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(claimParrotTokens.pending, (state) => {
            state.successes = [];
            state.failures = [];
            state.status = 'claiming';
        })
            .addCase(fetchParrotPassTokenClaimStatus.rejected, (state) => {
            state.status = 'error';
        })
            .addCase(fetchParrotPassesTokenClaimStatus.rejected, (state) => {
            state.status = 'error';
        })
            .addCase(claimParrotTokens.rejected, (state) => {
            state.status = 'error';
        });
    }
});
export const claimParrotTokensReducer = claimParrotTokensSlice.reducer;
